import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="why-choose-us section">
      <div className="container">
        <h2 className="section-title animate-fade-in-up">Why Choose Totalguard Workwear Rosslyn</h2>
        
        <div className="features-grid">
          <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <div className="feature-icon"></div>
            <h3 className="feature-title">Certified Quality and Compliance</h3>
            <p className="feature-description">
              All our products meet or exceed industry standards and safety regulations. We ensure every item 
              in our inventory is certified and compliant with local and international safety requirements, 
              giving you complete confidence in your protective equipment.
            </p>
          </div>
          
          <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="feature-icon"></div>
            <h3 className="feature-title">Durable and Comfortable Designs</h3>
            <p className="feature-description">
              We understand that PPE needs to be both protective and comfortable for extended wear. Our products 
              are engineered with durable materials and ergonomic designs that prioritize worker comfort without 
              compromising on safety standards.
            </p>
          </div>
          
          <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <div className="feature-icon"></div>
            <h3 className="feature-title">Fast, Reliable Service</h3>
            <p className="feature-description">
              Time is critical when it comes to safety equipment. Our efficient supply chain and dedicated team 
              ensure quick turnaround times and reliable delivery, so you never have to compromise on protection 
              due to equipment delays.
            </p>
          </div>
          
          <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <div className="feature-icon"></div>
            <h3 className="feature-title">Custom Solutions for Different Industries</h3>
            <p className="feature-description">
              Every industry has unique safety challenges. We work closely with our clients to understand their 
              specific requirements and provide customized PPE solutions that address their particular workplace 
              hazards and operational needs.
            </p>
          </div>
          
          <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
            <div className="feature-icon"></div>
            <h3 className="feature-title">Expert Consultation and Support</h3>
            <p className="feature-description">
              Our knowledgeable team provides expert guidance to help you choose the right protective equipment 
              for your specific applications. From initial consultation to ongoing support, we're here to ensure 
              you make informed decisions about your safety needs.
            </p>
          </div>
          
          <div className="feature-card animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
            <div className="feature-icon"></div>
            <h3 className="feature-title">Competitive Pricing and Value</h3>
            <p className="feature-description">
              Quality protection shouldn't break the bank. We offer competitive pricing on all our PPE products 
              while maintaining the highest quality standards, ensuring you get excellent value for your safety 
              investment.
            </p>
          </div>
        </div>
        
        <div className="why-choose-us-cta animate-fade-in-up" style={{ animationDelay: '0.7s' }}>
          <h3>Ready to Upgrade Your Safety Standards?</h3>
          <p>Experience the Totalguard Workwear Rosslyn difference today. Contact us to discuss your PPE requirements and discover how we can enhance your workplace safety.</p>
          <a href="#contact" className="btn">Get Started Today</a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
